import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './form-input.scss';

const FormInput = ({ className, input, label, meta, ...props }) => (
  <div className="form-input">
    {label && (
      <label htmlFor={input.name} className="form-input__label">
        {label}
      </label>
    )}
    <input
      type="text"
      id={input.name}
      value={input.value || ''}
      autoComplete="off"
      {...props}
      {...input}
      className={classnames('form-input__input', className, {
        'form-input__input--error': meta.touched && meta.error,
      })}
    />
    {meta.touched && meta.error && (
      <div className="form-input__error">{meta.error}</div>
    )}
  </div>
);

FormInput.propTypes = {
  className: PropTypes.string,
  input: PropTypes.shape({}).isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    touched: PropTypes.bool,
  }).isRequired,
};

FormInput.defaultProps = {
  className: '',
  label: '',
};

export default FormInput;
